
  import noneRuntime$_4b_451wDXPbHkO1fXTVAvBdIe7T_Z3EMEmutwSXS9n62A from '/home/snaumann/Development/public_html/dundp/public/node_modules/.pnpm/@nuxt+image@2.0.0_db0@0.3.4_ioredis@5.10.1_magicast@0.5.2_srvx@0.11.15/node_modules/@nuxt/image/dist/runtime/providers/none'
import gsRuntime$AwPBl41v0X33EwtN1fAxbAx50_45Bw7EyUXvpLDOH7j1Q from '/home/snaumann/Development/public_html/dundp/api/vendors/gsmaterials/imgProvider.ts'
  
  export const imageOptions = {
    ...{
  "screens": {
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "2xl": 1536
  },
  "presets": {},
  "provider": "gs",
  "domains": [],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp"
  ]
},
    /** @type {"gs"} */
    provider: "gs",
    providers: {
        ['none']: { setup: noneRuntime$_4b_451wDXPbHkO1fXTVAvBdIe7T_Z3EMEmutwSXS9n62A, defaults: true },
  ['gs']: { setup: gsRuntime$AwPBl41v0X33EwtN1fAxbAx50_45Bw7EyUXvpLDOH7j1Q, defaults: undefined }
    }
  }
